export default function linearInterpolate(arr = []) {
  let result = [...arr]; // 创建一个副本以避免修改原数组
  // 遍历数组，进行线性插值
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === null) {
      // 找到前后两个非 null 的值
      let prevIndex = i - 1;
      let nextIndex = i + 1;
      while (prevIndex >= 0 && arr[prevIndex] === null) {
        prevIndex--;
      }
      while (nextIndex < arr.length && arr[nextIndex] === null) {
        nextIndex++;
      }

      // 如果前后都有非 null 的值，进行线性插值
      if (prevIndex >= 0 && nextIndex < arr.length) {
        let x1 = prevIndex;
        let y1 = arr[prevIndex];
        let x2 = nextIndex;
        let y2 = arr[nextIndex];
        let x = i;
        let y = y1 + ((x - x1) * (y2 - y1)) / (x2 - x1);

        result[i] = y;
        result[prevIndex] = arr[prevIndex];
        result[nextIndex] = arr[nextIndex];
      } else {
        // 如果没有前后两个非 null 的值，保持 null
        result[i] = null;
      }
    }
  }
  return result;
}
